import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Link } from '@atlassian/amkt-common';
import { ButtonClickedEvent, withAnalytics } from '@atlassian/mpac-analytics';
import React, { Component } from 'react';
import { ANALYTICS_SUBJECT_ID_NAV_BAR_VIEW_SWITCHER } from '../../analytics/Events';
import { jsx as _jsx } from "react/jsx-runtime";
export class NavBarViewSwitcherBase extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "switchView", e => {
      e.preventDefault();
      this.props.fireAnalyticsEvent({
        eventType: ButtonClickedEvent,
        actionSubjectId: ANALYTICS_SUBJECT_ID_NAV_BAR_VIEW_SWITCHER,
        attributes: {
          label: this.props.label
        }
      });
      this.props.history.push({
        pathname: this.props.href
      });
    });
    _defineProperty(this, "render", () =>
    /*#__PURE__*/
    _jsx(Link, {
      href: this.props.href,
      onClick: this.switchView,
      children: this.props.label
    }));
  }
}
export default withAnalytics(NavBarViewSwitcherBase);